import { CreateEventFeedbackForm, EventFeedback } from '@/types/feedback';
import { Response } from '@/types/response';
import { api } from '@/utils/axios';

export const submitEventFeedback = async (
  eventId: number,
  data: CreateEventFeedbackForm,
): Promise<Response<EventFeedback>> => {
  const res = await api.post(`/app-web/events/${eventId}/feedback`, {
    event_id: eventId,
    ...data,
  });
  return res.data;
};
